import { Box, Stack } from '@mui/material'
import React from 'react'
import { TextLabel, TextValue } from '../../styles'
import { useSelector } from 'react-redux';
import { numberBoxSx } from './styles';

export const EmailBox = () => {
  const userData = useSelector((state) => state.userData.data);
  const userEmail = userData?.account?.email;
  return (
    <Box mx={3}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={numberBoxSx.headerStack}
        >
          <TextLabel>Email</TextLabel>
          <TextValue>{userEmail}</TextValue>
          <Box minWidth={'30px'}></Box>
        </Stack>
        <hr />
      </Box>
  )
}
